import { useAuth0 } from '@auth0/auth0-react'
import { Button } from 'tcm-chakra-ui'
import { getAuthRedirectUri } from '../../auth/redirectUri'

export function LogoutButton() {
  const { logout } = useAuth0()
  const redirectUri = getAuthRedirectUri()

  return (
    <Button
      variant="outline"
      borderColor="whiteAlpha.700"
      color="text.white"
      size="sm"
      css={{
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: 'whiteAlpha.700',
        borderRadius: 'md',
        backgroundColor: 'transparent',
      }}
      onClick={() => {
        logout({
          logoutParams: {
            returnTo: redirectUri || window.location.origin,
          },
        })
      }}
      _hover={{ bg: 'whiteAlpha.200' }}
    >
      Log out
    </Button>
  )
}
